import { render } from "./GoogleGranularConsentErrorPage.vue?vue&type=template&id=a7728fde&scoped=true"
import script from "./GoogleGranularConsentErrorPage.vue?vue&type=script&lang=js"
export * from "./GoogleGranularConsentErrorPage.vue?vue&type=script&lang=js"

import "./GoogleGranularConsentErrorPage.vue?vue&type=style&index=0&id=a7728fde&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7728fde"]])

export default __exports__